// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./account.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./edit.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./help.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./language.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./logout.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./settings.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./crown.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./quickstart.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./faq.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icons_sideMenu_account::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.icons_sideMenu_edit::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.icons_sideMenu_help::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.icons_sideMenu_language::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.icons_sideMenu_logout::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.icons_sideMenu_settings::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.icons_sideMenu_crown::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.icons_sideMenu_quickstart::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.icons_sideMenu_faq::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}`, "",{"version":3,"sources":["webpack://./src/assets/sideMenu/icons.css"],"names":[],"mappings":"AAAA;IACI,yDAAsC;AAC1C;;AAEA;IACI,yDAAmC;AACvC;;AAEA;IACI,yDAAmC;AACvC;;AAEA;IACI,yDAAuC;AAC3C;;AAEA;IACI,yDAAqC;AACzC;;AAEA;IACI,yDAAuC;AAC3C;;AAEA;IACI,yDAAoC;AACxC;;AAEA;IACI,yDAAyC;AAC7C;;AAEA;IACI,yDAAkC;AACtC","sourcesContent":[".icons_sideMenu_account::before{\n    background-image: url('./account.svg');\n}\n\n.icons_sideMenu_edit::before{\n    background-image: url('./edit.svg');\n}\n\n.icons_sideMenu_help::before{\n    background-image: url('./help.svg');\n}\n\n.icons_sideMenu_language::before{\n    background-image: url('./language.svg');\n}\n\n.icons_sideMenu_logout::before{\n    background-image: url('./logout.svg');\n}\n\n.icons_sideMenu_settings::before{\n    background-image: url('./settings.svg');\n}\n\n.icons_sideMenu_crown::before{\n    background-image: url('./crown.svg');\n}\n\n.icons_sideMenu_quickstart::before{\n    background-image: url('./quickstart.svg');\n}\n\n.icons_sideMenu_faq::before{\n    background-image: url('./faq.svg');\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
